export default [
  {
    path: '/admin/pos/customer-orders',
    name: 'customer-order',
    meta: { requiresAuth: true },
    component: () => import('@/pages/restaurant-sale/customer-order.vue')
  }
]
